import { render, staticRenderFns } from "./StarterPackResultsSection.vue?vue&type=template&id=342de95c&scoped=true"
import script from "./StarterPackResultsSection.vue?vue&type=script&lang=js"
export * from "./StarterPackResultsSection.vue?vue&type=script&lang=js"
import style0 from "./StarterPackResultsSection.vue?vue&type=style&index=0&id=342de95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342de95c",
  null
  
)

export default component.exports